module.exports = __webpack_public_path__ + "static/media/close.3cd02c5e.svg";